export type Manga = {
  id: string;
  title: string;
  category: "guide" | "serial" | "hot";
  season: string;
  status: string;
  rating: number;
  update: string;
  cover: string;
  tags: string[];
  synopsis: string;
  chapters: number;
  author: string;
};

export const mangaList: Manga[] = [
  {
    id: "papaya-001",
    title: "星渊回响",
    category: "guide",
    season: "2026夏",
    status: "连载中",
    rating: 9.1,
    update: "每周三更新",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20young%20hero%20standing%20against%20a%20glowing%20star%20nebula%20sky%2C%20warm%20orange%20and%20coral%20color%20palette%2C%20dynamic%20brush%20strokes%2C%20cinematic%20composition%2C%20clean%20editorial%20layout%2C%20vibrant%20and%20detailed%20digital%20painting&width=600&height=800&seq=papaya-cover-01&orientation=portrait",
    tags: ["热血", "奇幻", "战斗"],
    synopsis: "少年星辰在图书馆意外唤醒了沉睡的星渊之力，从此踏上收集破碎星核、守护家园的旅程。新番首发，燃向热血开篇，开局即高能。",
    chapters: 24,
    author: "北辰工作室",
  },
  {
    id: "papaya-002",
    title: "樱与千层塔",
    category: "guide",
    season: "2026夏",
    status: "连载中",
    rating: 8.6,
    update: "每周五更新",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20girl%20with%20sakura%20petals%20floating%20around%20a%20magic%20layered%20tower%2C%20soft%20warm%20pink%20and%20cream%20tones%2C%20gentle%20pastel%20watercolor%20style%2C%20whimsical%20fantasy%2C%20clean%20editorial%20composition%2C%20charming%20and%20bright&width=600&height=800&seq=papaya-cover-02&orientation=portrait",
    tags: ["恋爱", "奇幻", "治愈"],
    synopsis: "想登上传说中一千层的魔法塔，必须先通过九十九道关于「爱」的试炼。青梅竹马与神秘塔主的奇妙日常，今夏最治愈的新番。",
    chapters: 18,
    author: "桃木工房",
  },
  {
    id: "papaya-003",
    title: "铁翼突击",
    category: "guide",
    season: "2026夏",
    status: "连载中",
    rating: 8.9,
    update: "每周二更新",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20mecha%20pilot%20in%20an%20orange%20exosuit%20with%20wings%2C%20explosive%20action%20background%2C%20warm%20amber%20and%20crimson%20palette%2C%20sharp%20military%20style%2C%20high%20contrast%2C%20dynamic%20mecha%20combat%20scene%2C%20editorial%20cover%20layout&width=600&height=800&seq=papaya-cover-03&orientation=portrait",
    tags: ["机战", "科幻", "热血"],
    synopsis: "地底文明觉醒，人类靠「铁翼部队」保卫天空。王牌飞行员与旧识的宿命对决，机甲粉丝今夏不可错过的大作。",
    chapters: 30,
    author: "铁幕动画",
  },
  {
    id: "papaya-004",
    title: "云端食堂",
    category: "guide",
    season: "2026夏",
    status: "连载中",
    rating: 8.4,
    update: "每周六更新",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20cozy%20floating%20sky%20restaurant%20with%20steaming%20delicious%20food%2C%20warm%20golden%20sunlight%2C%20comfort%20food%20illustration%2C%20soft%20warm%20yellow%20and%20orange%20tones%2C%20appetizing%20and%20heartwarming%2C%20clean%20editorial%20layout&width=600&height=800&seq=papaya-cover-04&orientation=portrait",
    tags: ["美食", "日常", "治愈"],
    synopsis: "一位会飞的美食家把食堂开到了云端，招待来自各地的神奇客人。一道料理一段故事，暖胃又暖心。",
    chapters: 15,
    author: "暖阳社",
  },
  {
    id: "papaya-005",
    title: "山海旅人",
    category: "serial",
    season: "2026春",
    status: "连载新开",
    rating: 8.7,
    update: "每周四更新",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20traveler%20walking%20through%20legendary%20mountains%20with%20mythical%20beasts%2C%20traditional%20Chinese%20ink%20wash%20with%20warm%20coral%20accents%2C%20epic%20fantasy%20landscape%2C%20artistic%20and%20detailed%2C%20editorial%20cover%20composition&width=600&height=800&seq=papaya-cover-05&orientation=portrait",
    tags: ["国风", "奇幻", "冒险"],
    synopsis: "少年持山海图踏入上古秘境，收服异兽、解开山河封印。国风奇幻长篇，新开连载即引发追更热潮。",
    chapters: 26,
    author: "山海工作室",
  },
  {
    id: "papaya-006",
    title: "倒数第三名",
    category: "serial",
    season: "2026春",
    status: "连载新开",
    rating: 8.2,
    update: "每周一更新",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20high%20school%20sports%20club%20underdogs%20in%20a%20warm%20orange%20field%2C%20energetic%20youthful%20style%2C%20motivational%20team%20spirit%2C%20bright%20and%20colorful%2C%20dynamic%20composition%2C%20clean%20editorial%20layout&width=600&height=800&seq=papaya-cover-06&orientation=portrait",
    tags: ["运动", "青春", "热血"],
    synopsis: "一所垫底高中的田径社，一群总拿倒数第三的少年，决定用一个学期打进全国赛。燃向运动新连载。",
    chapters: 22,
    author: "疾风社",
  },
  {
    id: "papaya-007",
    title: "糖霜侦探社",
    category: "serial",
    season: "2026春",
    status: "连载新开",
    rating: 8.5,
    update: "每周日更新",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20cute%20detective%20duo%20with%20dessert%20themed%20accessories%2C%20sweet%20pastel%20warm%20tones%2C%20mystery%20comedy%20style%2C%20playful%20and%20colorful%2C%20clean%20editorial%20composition%2C%20charming%20character%20art&width=600&height=800&seq=papaya-cover-07&orientation=portrait",
    tags: ["推理", "搞笑", "日常"],
    synopsis: "甜品店楼上的私人侦探社，破案全靠吃。一边吃蛋糕一边破解小镇谜题，轻松又上头。",
    chapters: 19,
    author: "奶油制片",
  },
  {
    id: "papaya-008",
    title: "墨色长安",
    category: "serial",
    season: "2026春",
    status: "连载新开",
    rating: 9.0,
    update: "每周二更新",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20ancient%20Chinese%20city%20Changan%20at%20night%20with%20lanterns%20and%20a%20swordsman%2C%20warm%20gold%20and%20crimson%20palette%2C%20wuxia%20style%2C%20atmospheric%20and%20dramatic%2C%20rich%20detail%2C%20editorial%20cover%20composition&width=600&height=800&seq=papaya-cover-08&orientation=portrait",
    tags: ["武侠", "历史", "剧情"],
    synopsis: "盛唐长安的夜幕之下，一名墨衣剑客游走于权谋与江湖之间。画风绝美，剧情层层反转的武侠新篇。",
    chapters: 35,
    author: "长歌文化",
  },
  {
    id: "papaya-009",
    title: "白日梦游者",
    category: "hot",
    season: "2026夏",
    status: "连载中",
    rating: 9.3,
    update: "每周五更新",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20dreamy%20surreal%20landscape%20with%20a%20floating%20dreamer%20character%2C%20warm%20sunset%20orange%20and%20rose%20tones%2C%20whimsical%20surrealism%2C%20soft%20glowing%20light%2C%20imaginative%20and%20beautiful%2C%20editorial%20cover%20layout&width=600&height=800&seq=papaya-cover-09&orientation=portrait",
    tags: ["奇幻", "治愈", "成长"],
    synopsis: "只要睡着，就能进入任何人的梦境。人气榜首，用温柔的方式讲述遗憾与和解，让人读完整夜难眠。",
    chapters: 40,
    author: "星绘动画",
  },
  {
    id: "papaya-010",
    title: "赤炎之刃",
    category: "hot",
    season: "2026夏",
    status: "连载中",
    rating: 8.8,
    update: "每周三更新",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20swordsman%20wielding%20a%20blazing%20flame%20sword%2C%20fiery%20orange%20and%20deep%20red%20palette%2C%20epic%20battle%20fantasy%2C%20dynamic%20action%20pose%2C%20high%20detail%20character%20art%2C%20editorial%20cover%20composition&width=600&height=800&seq=papaya-cover-10&orientation=portrait",
    tags: ["热血", "战斗", "冒险"],
    synopsis: "拥有赤炎之刃的少年骑士，誓要斩断魔王的诅咒。高燃战斗名场面不断，热血榜常年霸榜。",
    chapters: 55,
    author: "焰火动画",
  },
  {
    id: "papaya-011",
    title: "猫咪邮差",
    category: "hot",
    season: "2026夏",
    status: "连载中",
    rating: 8.9,
    update: "每周六更新",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20cute%20cat%20mailman%20delivering%20letters%20in%20a%20cozy%20warm%20town%2C%20soft%20orange%20and%20cream%20palette%2C%20adorable%20wholesome%20style%2C%20warm%20storybook%20illustration%2C%20clean%20editorial%20layout&width=600&height=800&seq=papaya-cover-11&orientation=portrait",
    tags: ["萌宠", "治愈", "日常"],
    synopsis: "小镇的猫咪邮差每天为居民送信，也悄悄传递着没说出口的心意。全网催更的治愈小故事。",
    chapters: 48,
    author: "软绵绵工房",
  },
  {
    id: "papaya-012",
    title: "轮回灯塔",
    category: "hot",
    season: "2026夏",
    status: "连载中",
    rating: 9.0,
    update: "每周四更新",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20lone%20lighthouse%20on%20a%20cliff%20over%20a%20mysterious%20ocean%2C%20warm%20amber%20twilight%20sky%2C%20melancholic%20beautiful%20scene%2C%20surreal%20fantasy%2C%20atmospheric%20lighting%2C%20editorial%20cover%20composition&width=600&height=800&seq=papaya-cover-12&orientation=portrait",
    tags: ["悬疑", "奇幻", "剧情"],
    synopsis: "灯塔看守人每隔七天会重复同一天，直到找出小镇失踪案的真相。烧脑悬疑+感人催泪，讨论度超高。",
    chapters: 33,
    author: "潮汐社",
  },
];

export const categoryMeta = {
  guide: { name: "新番导视", desc: "当季新作抢先看，新番导视帮你快速锁定值得追的作品。" },
  serial: { name: "连载新开", desc: "连载新开一站掌握，第一时间发现刚刚开坑的长篇佳作。" },
  hot: { name: "热门新番", desc: "热门新番同步追，全网都在讨论的作品都在这。" },
} as const;